// ═══════════════════════════════════════════════════════════════════════
// APPLY PAGE ("/apply") — direct-booking copy.
// Anyone landing here from any funnel has ONE job: book the call.
// Voice: Hormozi/Cardone — short punches, zero fluff, straight answers.
// ═══════════════════════════════════════════════════════════════════════

export const APPLY = {
  nav: {
    backLabel: "Back To Home",
    ctaLabel: "Book Your Call",
    ctaTarget: "calendar",
  },
  hero: {
    eyebrow: "One Call. One Decision.",
    headlineStart: "Book The Call.",
    headlineAccent: "Get Your Answer.",
    sub: "You've seen the training path. One 15-minute call tells you exactly where you fit, what track to run, and what it takes to earn a real seat in high-ticket sales. No fluff. No pitch. Just the answer.",
    ctaLabel: "Book Your Call Now",
    ctaTarget: "calendar",
    trust: "No pressure. No pitch. If it's a fit, you'll know in 15 minutes. If it's not, you'll know that too.",
  },
  serious: {
    eyebrow: "Who This Is For",
    headline: "We Only Book Serious Applicants",
    lede: "7FCC is not for people who want to watch videos and feel productive. It's for people ready to be coached hard, make the calls, and put in the reps every single day.",
    cards: [
      {
        num: "01",
        title: "You Take Coaching — Not Offense",
        desc: "You want the truth about your calls, even when it stings. Correction is your advantage. Ego is not invited.",
      },
      {
        num: "02",
        title: "You Make The Calls",
        desc: "The money is on the phone and you know it. You pick up the dials and put the work on the board.",
      },
      {
        num: "03",
        title: "You Track, Review, Improve — Daily",
        desc: "You log your numbers. You watch the tape. You fix what it shows. Every single day.",
      },
    ],
    panel: {
      title: "If That's You, There's Only One Move Left",
      body: "Willing to be coached? Willing to make the calls? Then stop deciding and start booking — the conversation takes 15 minutes and you'll leave with a straight answer.",
      ctaLabel: "I'm Serious — Book The Call",
      ctaTarget: "calendar",
    },
  },
  onTheCall: {
    headline: "15 Minutes. Zero Fluff.",
    lede: "A short, focused conversation. Here's exactly what gets covered — no surprises, no recycled pitch.",
    steps: [
      {
        title: "Where You Are Right Now",
        desc: "Your sales story so far — what's worked, what hasn't, and what's been in the way.",
      },
      {
        title: "What You Actually Want",
        desc: "The time you can really commit and the result you're hunting for.",
      },
      {
        title: "Setter Or Closer — The Honest Read",
        desc: "A straight answer on which track fits your strengths, your goals, and your season.",
      },
      {
        title: "Your First 30 Days",
        desc: "If it's a fit: exactly how you start and what your first month inside 7FCC looks like.",
      },
    ],
  },
  booking: {
    eyebrow: "Book Your Call",
    headline: "The Next Move Is Yours",
    sub: "Book the call and we'll tell you straight whether 7FCC is the right environment for you — and what it takes to earn your seat.",
    ctaLabel: "Book Your Call Now",
    ctaTarget: "calendar",
    note: "Serious applicants only. Show up ready to be honest about where you are.",
  },
  calendar: {
    eyebrow: "Live Calendar",
    headline: "Choose Your Time",
    lede: "Grab a slot that works for you and show up ready. We'll see you on the call.",
    embed: {
      src: "https://api.leadconnectorhq.com/widget/booking/tVwluP20CIDT7QbxsUry",
      iframeId: "FvG2UKXYAawptC73qAou_1791244822176",
      title: "Book a call with 7 Figure Closing Club",
      scriptSrc: "https://link.msgsndr.com/js/form_embed.js",
    },
  },
};
